module.exports = __webpack_public_path__ + "static/media/QA_engineers_amber.75b2d092.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/QA_engineers_amber.svg
// module id = 1093
// module chunks = 2